module.exports = __webpack_public_path__ + "img/celt.e7e52850.webp";